import { Visit } from "../../CRUDs/entities/Visit";
import { Customer } from "../../CRUDs/entities/Customer";
import { checkActionAttribute } from "./checkActionAttribute";

export const visitsModalActionsListners = (target, actionsWindow, parents=null) => {

    checkActionAttribute([
        { attribute: 'data-customer-active',     className: 'edit-visit' },
        { attribute: 'data-customer-active',     className: 'visit-action' },
        { attribute: 'data-customer-active',     className: 'contact' },
        { attribute: 'data-customer-active',     className: 'attachments' },
    ], target, actionsWindow, parents);


    actionsWindow.find('.action').off();

    const visitId = target.parent().attr('data-id');
    const customerId = target.parent().attr('data-customer-id');

    const customer = new Customer(customerId);

    const visit = new Visit(visitId);

    actionsWindow.find('.action').off();

    // view attachments
    actionsWindow.find('.action.attachments').on('click', (e) => {
        $('.modal-window-actions').hide();
        visit.viewAttachments();
    });

    // contact customer
    actionsWindow.find('.action.contact').on('click', (e) => {
        customer.openModal('contact');
    });

    // view details
    actionsWindow.find('.action.view-visit').on('click', (e) => {
        visit.openModal('view');
    });

    // edit visit
    actionsWindow.find('.action.edit-visit').on('click', (e) => {
        visit.openModal('edit');
    });

    // view logs
    actionsWindow.find('.action.view-logs').on('click', (e) => {
        visit.openModal('logs');
    });
}
